exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input {\n  width: 100%;\n  background-color: #E5E5E5;\n  border-radius: 3px;\n  margin: 5px;\n  padding: 5px;\n}\n\n.card-header {\n  background-color: #616161;\n  height: 60px;\n}\n\n.card-header-title {\n  color: #fff;\n  font-size: 20px;\n  font-weight: 400;\n  line-height: 1.4;\n}\n\n:-ms-input-placeholder {\n  color: #958FA2;\n}\n\n::placeholder {\n  color: #958FA2;\n}\n\nbutton {\n  width: 250px;\n  max-width: 250px;\n  color: black;\n  margin: 0 auto;\n}\n\n.foot {\n  vertical-align : bottom;\n}\n\ntextarea {\n  margin: 5px;\n  padding: 10px;\n  width: 100%;\n}\n\n.subHeader {\n  text-align: center;\n}\n\n.oldMeetingColumn {\n  padding: 15px;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/trevor/src/src-westoaks3/west-oaks/src/app/edit-meeting/edit-meeting.component.css
// module id = ../../../../../src/app/edit-meeting/edit-meeting.component.css
// module chunks = main